import styled from "@emotion/styled";
import { Box, Button, Stack, Typography } from "@mui/material";
import { TextField } from "components/UI";
import { sha256 } from "crypto-hash";
import { useState } from "react";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const PasswordContainer = styled(Box)`
  background: white;
  padding: 32px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
`;

const hashPassword = async str => {
  return await sha256(str);
};

const HASH = "ab191a7ea4503f640a1f7ba7d51b061b22852b6be8558b76abc8f8cd9a6246dd";

export const PasswordProtection = ({ onPasswordCorrect }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();
    const hashedInput = await hashPassword(password);
    if (hashedInput === HASH) {
      onPasswordCorrect();
    } else {
      setError("Incorrect password");
    }
  };

  return (
    <Overlay>
      <PasswordContainer>
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Enter Super Admin Password
            </Typography>
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              error={!!error}
              helperText={error}
              register={() => {}}
            />
            <Button type="submit" variant="contained" fullWidth>
              Submit
            </Button>
          </Stack>
        </form>
      </PasswordContainer>
    </Overlay>
  );
};
